const timerCookieName = 'timers'

const setCookie = (name: string, value: any) => {
    let expires = ''
    const date = new Date()
    date.setTime(date.getTime() + (365 * 10 * 24 * 60 * 60 * 1000))
    expires = '; expires=' + date.toUTCString()
    document.cookie = name + '=' + JSON.stringify(value)  + expires + '; path=/'
}

const getCookie = (name: string) => {
    const nameEQ = name + '='
    const ca = document.cookie.split(';')

    for (let i = 0; i < ca.length; i++) {
        let c = ca[i]
        while (c.charAt(0) === ' ') c = c.substring(1,c.length)
        if (c.indexOf(nameEQ) === 0) return JSON.parse(c.substring(nameEQ.length, c.length))
    }
    return null
}

export {
    timerCookieName,
    setCookie,
    getCookie
}